import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const SizeLabel = styled.div`
    display: flex;
    align-items: center;

    svg {
        margin-right: 9px;
        color: ${token.gray600};
    }
`;
